const drak = {
    isDark: true,
    background: "#fff",
    colors: "#000",
}

export default drak